"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Monograph = void 0;
const print_util_1 = require("../../print-util");
/**
 * Page 4
 * - Monograph
 */
class Monograph extends print_util_1.PrintUtil {
    constructor(printMeta, lastPage) {
        super();
        this.printMeta = printMeta;
        this.lastPage = lastPage;
        this.make = () => {
            const { monograph } = this.printMeta;
            const pageBreak = this.lastPage ? "" : "after";
            return [
                {
                    style: "monographText",
                    stack: [
                        monograph.defaultImportantText,
                        monograph.hasDataCommonBrand || "",
                        monograph.stack || ""
                    ],
                    pageBreak
                }
            ];
        };
    }
}
exports.Monograph = Monograph;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/sheets/monograph/monograph.ts
// module id = 2738
// module chunks = 0 1